import {AlertIcon} from '@primer/octicons-react'

import styles from './ReferencedEventInner.module.css'

export function ReferencedEventVerificationStatusFailure(): React.ReactElement {
  return (
    <span
      className={styles.referencedEventVerificationStatusFailure}
      data-testid="referenced-event-verification-status-failure"
    >
      <AlertIcon size={16} /> Error
    </span>
  )
}
